import type { SelectChangeEvent } from "@mui/material";
import { MenuItem, Select } from "@mui/material";
import type { BooleanObjectFilter } from "../../api/types/objectTypes";

interface Props {
  filter: BooleanObjectFilter;
  onFilterChange: (filter: BooleanObjectFilter) => void;
}

const ObjectBooleanFilterEditorContent = ({ filter, onFilterChange }: Props) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onFilterChange({ value: event.target.value === "true" });
  };

  return (
    <Select value={String(filter.value)} onChange={handleChange} sx={{ flex: "0 0 12.5rem" }}>
      <MenuItem value="true">Yes</MenuItem>
      <MenuItem value="false">No</MenuItem>
    </Select>
  );
};

export default ObjectBooleanFilterEditorContent;
